import { Link } from "./Style";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as SetaDireitaIcon } from "../../../assets/icons/seta_direita.svg";
import { useEffect, useState } from "react";

interface TmpLinkCustomProps {
    href: string;
    target?: string;
    ariaLabel?: string;
    disabled?: boolean;
    icon?: boolean;
    marginTop?: number;
    marginBottom?: number;
    marginLeft?: number;
    download?: boolean;
    marginRight?: number;
    color?: string;
    children: React.ReactNode;
    onClick?: (e: any) => void;
}

export default function TmpLinkCustom(props: TmpLinkCustomProps) {


  const [fileName, setFileName] = useState<string>();

  useEffect(() => {

    if(props.download && props.href){
      const fileName = props.href.split('/').pop();
      setFileName(fileName);
    }

  }, [props.download, props.href]);

  // Passing style props to styled component
  Link.defaultProps = style;

  return (
    <Link
      className="tmp-link"
      href={props.href}
      target={props.target}
      disabled={props.disabled ? true : false}
      icon={props.icon ? true : false}
      download={props.download ? fileName : null}
      marginTop={props.marginTop ? props.marginTop : 0}
      marginBottom={props.marginBottom ? props.marginBottom : 0}
      marginLeft={props.marginLeft ? props.marginLeft : 0}
      marginRight={props.marginRight ? props.marginRight : 0}
      color={props.color ? props.color : "#2C6EF2"}
      display={"inline-flex "}
      aria-label={props.ariaLabel}
    >
      {props.children}

      {props.icon && (
        <div className="tmp-link__icon">
          <TmpIconCustom icon={<SetaDireitaIcon />} size="sm" />
        </div>
      )}
    </Link>
  );

}